import { useMemo } from "react";

import { getRegionLabel } from "Libs/utils";
import { regionSelector } from "Reducers/project/region";
import { useAppSelector } from "Store/hooks";

import type { RootState } from "Store/configureStore";

export const useRegionLabel = (regionId: string) => {
  const region = useAppSelector((state: RootState) =>
    regionSelector(state, { regionId })
  );
  return useMemo(() => {
    return getRegionLabel(region?.label || regionId);
  }, [region, regionId]);
};
